// extracted by mini-css-extract-plugin
module.exports = {"description":"StoryDescription_description__DiCkt","descriptionContainer":"StoryDescription_descriptionContainer__I4ue3","topic":"StoryDescription_topic__KARib"};